const ACHIEVEMENTS_KEY = 'rondaybaciga_achievements';

// Map internal IDs to platform achievement IDs (fill in after registering in stores)
const PLATFORM_ACHIEVEMENT_MAP = {
    // 'ronda_de_reyes': 'CgkI...',  // Google Play ID
    // 'partida_perfecta': 'CgkI...', // etc.
};

const ACHIEVEMENT_DEFINITIONS = [
    // ── General ──────────────────────────────────────────────────────────────
    {
        id: 'primeras_cartas',
        nameKey: 'achievements.primeras_cartas.name',
        descKey: 'achievements.primeras_cartas.desc',
        icon: '🃏',
        tier: 'bronze',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.gamesPlayed >= 1,
        progressValue: (stats) => stats.gamesPlayed,
        progressTarget: 1,
    },
    {
        id: 'jugador_habitual',
        nameKey: 'achievements.jugador_habitual.name',
        descKey: 'achievements.jugador_habitual.desc',
        icon: '🎮',
        tier: 'bronze',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.gamesPlayed >= 10,
        progressValue: (stats) => stats.gamesPlayed,
        progressTarget: 10,
    },
    {
        id: 'veterano',
        nameKey: 'achievements.veterano.name',
        descKey: 'achievements.veterano.desc',
        icon: '🏅',
        tier: 'silver',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.gamesPlayed >= 50,
        progressValue: (stats) => stats.gamesPlayed,
        progressTarget: 50,
    },
    {
        id: 'leyenda',
        nameKey: 'achievements.leyenda.name',
        descKey: 'achievements.leyenda.desc',
        icon: '🏆',
        tier: 'gold',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.gamesPlayed >= 100,
        progressValue: (stats) => stats.gamesPlayed,
        progressTarget: 100,
    },
    {
        id: 'cinco_centenario',
        nameKey: 'achievements.cinco_centenario.name',
        descKey: 'achievements.cinco_centenario.desc',
        icon: '🎖️',
        tier: 'gold',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.gamesPlayed >= 500,
        progressValue: (stats) => stats.gamesPlayed,
        progressTarget: 500,
    },
    {
        id: 'millar_partidas',
        nameKey: 'achievements.millar_partidas.name',
        descKey: 'achievements.millar_partidas.desc',
        icon: '🌟',
        tier: 'platinum',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.gamesPlayed >= 1000,
        progressValue: (stats) => stats.gamesPlayed,
        progressTarget: 1000,
    },
    {
        id: 'primera_victoria',
        nameKey: 'achievements.primera_victoria.name',
        descKey: 'achievements.primera_victoria.desc',
        icon: '⭐',
        tier: 'bronze',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.wins.total >= 1,
        progressValue: (stats) => stats.wins.total,
        progressTarget: 1,
    },
    {
        id: 'racha_ganadora',
        nameKey: 'achievements.racha_ganadora.name',
        descKey: 'achievements.racha_ganadora.desc',
        icon: '🔥',
        tier: 'silver',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.wins.total >= 10,
        progressValue: (stats) => stats.wins.total,
        progressTarget: 10,
    },
    {
        id: 'invicto',
        nameKey: 'achievements.invicto.name',
        descKey: 'achievements.invicto.desc',
        icon: '👑',
        tier: 'gold',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.wins.total >= 25,
        progressValue: (stats) => stats.wins.total,
        progressTarget: 25,
    },
    {
        id: 'cien_victorias',
        nameKey: 'achievements.cien_victorias.name',
        descKey: 'achievements.cien_victorias.desc',
        icon: '🥇',
        tier: 'platinum',
        category: 'general',
        type: 'stat',
        condition: (stats) => stats.wins.total >= 100,
        progressValue: (stats) => stats.wins.total,
        progressTarget: 100,
    },

    // ── Ronda ─────────────────────────────────────────────────────────────────
    {
        id: 'primera_ronda',
        nameKey: 'achievements.primera_ronda.name',
        descKey: 'achievements.primera_ronda.desc',
        icon: '♟️',
        tier: 'bronze',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.actions.player.rondas >= 1,
        progressValue: (stats) => stats.actions.player.rondas,
        progressTarget: 1,
    },
    {
        id: 'rondinero',
        nameKey: 'achievements.rondinero.name',
        descKey: 'achievements.rondinero.desc',
        icon: '🎰',
        tier: 'silver',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.actions.player.rondines >= 1,
        progressValue: (stats) => stats.actions.player.rondines,
        progressTarget: 1,
    },
    {
        id: 'ronda_de_reyes',
        nameKey: 'achievements.ronda_de_reyes.name',
        descKey: 'achievements.ronda_de_reyes.desc',
        icon: '👑',
        tier: 'gold',
        category: 'ronda',
        type: 'event',
        eventId: 'rondaDeReyes',
    },
    {
        id: 'maestro_caidas',
        nameKey: 'achievements.maestro_caidas.name',
        descKey: 'achievements.maestro_caidas.desc',
        icon: '⬇️',
        tier: 'silver',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.actions.player.caidas >= 20,
        progressValue: (stats) => stats.actions.player.caidas,
        progressTarget: 20,
    },
    {
        id: 'contragolpe',
        nameKey: 'achievements.contragolpe.name',
        descKey: 'achievements.contragolpe.desc',
        icon: '💥',
        tier: 'silver',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.actions.player.contracaidas >= 5,
        progressValue: (stats) => stats.actions.player.contracaidas,
        progressTarget: 5,
    },
    {
        id: 'san_vicente',
        nameKey: 'achievements.san_vicente.name',
        descKey: 'achievements.san_vicente.desc',
        icon: '✨',
        tier: 'gold',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.actions.player.sanVicentes >= 1,
        progressValue: (stats) => stats.actions.player.sanVicentes,
        progressTarget: 1,
    },
    {
        id: 'barrendero',
        nameKey: 'achievements.barrendero.name',
        descKey: 'achievements.barrendero.desc',
        icon: '🧹',
        tier: 'silver',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.actions.player.aseos >= 10,
        progressValue: (stats) => stats.actions.player.aseos,
        progressTarget: 10,
    },
    {
        id: 'partida_perfecta',
        nameKey: 'achievements.partida_perfecta.name',
        descKey: 'achievements.partida_perfecta.desc',
        icon: '💎',
        tier: 'platinum',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.funStats.perfectGames >= 1,
        progressValue: (stats) => stats.funStats.perfectGames,
        progressTarget: 1,
    },
    {
        id: 'remontada',
        nameKey: 'achievements.remontada.name',
        descKey: 'achievements.remontada.desc',
        icon: '🔄',
        tier: 'gold',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.funStats.comebacks >= 1,
        progressValue: (stats) => stats.funStats.comebacks,
        progressTarget: 1,
    },
    {
        id: 'arrastre',
        nameKey: 'achievements.arrastre.name',
        descKey: 'achievements.arrastre.desc',
        icon: '🌊',
        tier: 'gold',
        category: 'ronda',
        type: 'stat',
        condition: (stats) => stats.records.maxCardsHandTeam >= 30,
        progressValue: (stats) => stats.records.maxCardsHandTeam,
        progressTarget: 30,
    },

    // ── Báciga ────────────────────────────────────────────────────────────────
    {
        id: 'partida_perfecta_baciga',
        nameKey: 'achievements.partida_perfecta_baciga.name',
        descKey: 'achievements.partida_perfecta_baciga.desc',
        icon: '💎',
        tier: 'platinum',
        category: 'baciga',
        type: 'stat',
        condition: (stats) => (stats.funStats.perfectGamesBaciga || 0) >= 1,
        progressValue: (stats) => stats.funStats.perfectGamesBaciga || 0,
        progressTarget: 1,
    },
    {
        id: 'primera_baciga',
        nameKey: 'achievements.primera_baciga.name',
        descKey: 'achievements.primera_baciga.desc',
        icon: '🃏',
        tier: 'bronze',
        category: 'baciga',
        type: 'stat',
        condition: (stats) => stats.actions.player.bacigas >= 1,
        progressValue: (stats) => stats.actions.player.bacigas,
        progressTarget: 1,
    },
    {
        id: 'bacigote_de_oro',
        nameKey: 'achievements.bacigote_de_oro.name',
        descKey: 'achievements.bacigote_de_oro.desc',
        icon: '💫',
        tier: 'silver',
        category: 'baciga',
        type: 'stat',
        condition: (stats) => stats.actions.player.bacigotes >= 1,
        progressValue: (stats) => stats.actions.player.bacigotes,
        progressTarget: 1,
    },
    {
        id: 'las_cosas',
        nameKey: 'achievements.las_cosas.name',
        descKey: 'achievements.las_cosas.desc',
        icon: '🍀',
        tier: 'gold',
        category: 'baciga',
        type: 'stat',
        condition: (stats) => stats.actions.player.cosas >= 1,
        progressValue: (stats) => stats.actions.player.cosas,
        progressTarget: 1,
    },
    {
        id: 'treinta_y_una',
        nameKey: 'achievements.treinta_y_una.name',
        descKey: 'achievements.treinta_y_una.desc',
        icon: '3️⃣',
        tier: 'silver',
        category: 'baciga',
        type: 'stat',
        condition: (stats) => stats.actions.player.las31 >= 1,
        progressValue: (stats) => stats.actions.player.las31,
        progressTarget: 1,
    },
    {
        id: 'baja_baja',
        nameKey: 'achievements.baja_baja.name',
        descKey: 'achievements.baja_baja.desc',
        icon: '⚡',
        tier: 'platinum',
        category: 'baciga',
        type: 'stat',
        condition: (stats) => stats.records.lowestBacigaPlayer <= 3,
        progressValue: (stats) => stats.records.lowestBacigaPlayer === 99 ? null : stats.records.lowestBacigaPlayer,
        progressTarget: null,
    },

    // ── Especiales ────────────────────────────────────────────────────────────
    {
        id: 'coleccionista_100',
        nameKey: 'achievements.coleccionista_100.name',
        descKey: 'achievements.coleccionista_100.desc',
        icon: '🃏',
        tier: 'bronze',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 100,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 100,
    },
    {
        id: 'coleccionista_200',
        nameKey: 'achievements.coleccionista_200.name',
        descKey: 'achievements.coleccionista_200.desc',
        icon: '🎴',
        tier: 'bronze',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 200,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 200,
    },
    {
        id: 'puntos_100',
        nameKey: 'achievements.puntos_100.name',
        descKey: 'achievements.puntos_100.desc',
        icon: '🪙',
        tier: 'bronze',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 100,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 100,
    },
    {
        id: 'puntos_200',
        nameKey: 'achievements.puntos_200.name',
        descKey: 'achievements.puntos_200.desc',
        icon: '💵',
        tier: 'bronze',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 200,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 200,
    },
    {
        id: 'puntos_500',
        nameKey: 'achievements.puntos_500.name',
        descKey: 'achievements.puntos_500.desc',
        icon: '💶',
        tier: 'silver',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 500,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 500,
    },
    {
        id: 'puntos_1000',
        nameKey: 'achievements.puntos_1000.name',
        descKey: 'achievements.puntos_1000.desc',
        icon: '💰',
        tier: 'silver',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 1000,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 1000,
    },
    {
        id: 'puntos_2000',
        nameKey: 'achievements.puntos_2000.name',
        descKey: 'achievements.puntos_2000.desc',
        icon: '💎',
        tier: 'gold',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 2000,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 2000,
    },
    {
        id: 'puntos_5000',
        nameKey: 'achievements.puntos_5000.name',
        descKey: 'achievements.puntos_5000.desc',
        icon: '💎',
        tier: 'gold',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 5000,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 5000,
    },
    {
        id: 'puntos_10000',
        nameKey: 'achievements.puntos_10000.name',
        descKey: 'achievements.puntos_10000.desc',
        icon: '👑',
        tier: 'platinum',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalPointsScored >= 10000,
        progressValue: (stats) => stats.funStats.totalPointsScored,
        progressTarget: 10000,
    },
    {
        id: 'coleccionista',
        nameKey: 'achievements.coleccionista.name',
        descKey: 'achievements.coleccionista.desc',
        icon: '📦',
        tier: 'silver',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 500,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 500,
    },
    {
        id: 'coleccionista_mayor',
        nameKey: 'achievements.coleccionista_mayor.name',
        descKey: 'achievements.coleccionista_mayor.desc',
        icon: '📊',
        tier: 'gold',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 2000,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 2000,
    },
    {
        id: 'coleccionista_1000',
        nameKey: 'achievements.coleccionista_1000.name',
        descKey: 'achievements.coleccionista_1000.desc',
        icon: '🗂️',
        tier: 'silver',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 1000,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 1000,
    },
    {
        id: 'coleccionista_5000',
        nameKey: 'achievements.coleccionista_5000.name',
        descKey: 'achievements.coleccionista_5000.desc',
        icon: '🏛️',
        tier: 'gold',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 5000,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 5000,
    },
    {
        id: 'coleccionista_10000',
        nameKey: 'achievements.coleccionista_10000.name',
        descKey: 'achievements.coleccionista_10000.desc',
        icon: '👑',
        tier: 'platinum',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.funStats.totalCardsCollected >= 10000,
        progressValue: (stats) => stats.funStats.totalCardsCollected,
        progressTarget: 10000,
    },
    {
        id: 'todoterreno',
        nameKey: 'achievements.todoterreno.name',
        descKey: 'achievements.todoterreno.desc',
        icon: '🎯',
        tier: 'silver',
        category: 'especiales',
        type: 'stat',
        condition: (stats) => stats.wins.ronda >= 1 && stats.wins.baciga >= 1,
        progressValue: null,
        progressTarget: null,
    },
];

class AchievementsService {
    constructor() {
        this.definitions = ACHIEVEMENT_DEFINITIONS;
        this.unlocked = this._load();
        this.observers = [];
    }

    // Returns all achievement definitions merged with unlock status
    getAchievements() {
        return this.definitions.map((def) => ({
            ...def,
            unlocked: !!(this.unlocked[def.id]?.unlocked),
            unlockedAt: this.unlocked[def.id]?.unlockedAt || null,
        }));
    }

    // Returns only unlocked achievements count
    getUnlockedCount() {
        return Object.values(this.unlocked).filter((v) => v.unlocked).length;
    }

    getTotalCount() {
        return this.definitions.length;
    }

    isUnlocked(id) {
        return !!(this.unlocked[id]?.unlocked);
    }

    // Check all stat-based achievements; returns array of newly unlocked achievement objects
    // Pass silent=true to unlock without notifying observers (for retroactive checks)
    checkAchievements(stats, silent = false) {
        const newlyUnlocked = [];
        for (const def of this.definitions) {
            if (def.type !== 'stat') continue;
            if (this.isUnlocked(def.id)) continue;
            if (def.condition(stats)) {
                if (silent) {
                    this.unlocked[def.id] = { unlocked: true, unlockedAt: Date.now() };
                } else {
                    this.unlockAchievement(def.id);
                }
                newlyUnlocked.push(def);
            }
        }
        if (silent && newlyUnlocked.length > 0) {
            this._save();
        }
        return newlyUnlocked;
    }

    // Called for event-based achievements
    // eventId: 'rondaDeReyes'
    notifyEvent(eventId, _stats) {
        const def = this.definitions.find((d) => d.type === 'event' && d.eventId === eventId);
        if (!def) return;
        if (this.isUnlocked(def.id)) return;
        this.unlockAchievement(def.id);
        return def;
    }

    // Marks achievement as unlocked, persists, notifies
    unlockAchievement(id) {
        if (this.unlocked[id]?.unlocked) return;
        this.unlocked[id] = { unlocked: true, unlockedAt: Date.now() };
        this._save();
        const def = this.definitions.find((d) => d.id === id);
        if (def) {
            this._notifyObservers(def);
            this._syncPlatformAchievement(id);
        }
    }

    registerObserver(callback) {
        this.observers.push(callback);
    }

    unregisterObserver(callback) {
        this.observers = this.observers.filter((cb) => cb !== callback);
    }

    _notifyObservers(achievement) {
        window.dispatchEvent(new CustomEvent('achievementUnlocked', { detail: achievement }));
        this.observers.forEach((cb) => {
            try { cb(achievement); } catch (e) { /* ignore */ }
        });
    }

    // Stub for future Google Play / Apple Game Center integration
    async _syncPlatformAchievement(id) {
        const platformId = PLATFORM_ACHIEVEMENT_MAP[id];
        if (!platformId) return;

        try {
            const { Capacitor } = await import('@capacitor/core');
            const platform = Capacitor.getPlatform();
            if (platform === 'android') {
                // const { GameConnect } = await import('@capacitor-community/game-connect');
                // await GameConnect.unlockAchievement({ achievementId: platformId });
            } else if (platform === 'ios') {
                // const { GameConnect } = await import('@capacitor-community/game-connect');
                // await GameConnect.reportAchievement({ identifier: platformId, percentComplete: 100 });
            }
        } catch (_e) {
            // Plugin not installed or user not signed in — silently ignored
        }
    }

    _load() {
        try {
            const stored = localStorage.getItem(ACHIEVEMENTS_KEY);
            return stored ? JSON.parse(stored) : {};
        } catch (_e) {
            return {};
        }
    }

    _save() {
        try {
            localStorage.setItem(ACHIEVEMENTS_KEY, JSON.stringify(this.unlocked));
        } catch (_e) {
            console.error('Error saving achievements');
        }
    }
}

const achievementsService = new AchievementsService();
export default achievementsService;
